export default __webpack_public_path__ + "static/media/design-thinking.ace10865.svg";